import { Breadcrumb } from 'antd'

const ANTDBreadcrumb = ({ ...props }) => {
  return <Breadcrumb {...props} />
}

export default ANTDBreadcrumb
